<template>
  <v-dialog v-model="dialog" @click:outside="closeDialog" width="95vw" fullscreen>
    <v-app style="min-height: 100vh; background-color: #eff6fc">
      <div class="text-center">
        <v-overlay :value="dialog_loader">
          <v-progress-circular
            :size="90"
            :width="7"
            color="#036666"
            indeterminate
          ></v-progress-circular>
        </v-overlay>
      </div>

      <v-footer :padless="true" max-width="100%">
        <v-card
          elevation="0"
          width="100%"
          style="color: white; background: #09425a"
          class="text-center"
        >
          <!-- <v-card-title class="justify-center" style="word-break: break-word;"> -->
          <v-card-title class="justify-center" style="word-break: break-word; line-height: 1.5;">
            <!-- <span class="font-18 w-700">ความยินยอมในการเก็บรวบรวม ใช้ หรือเปิดเผยข้อมูลส่วนบุคคล <br /> -->
            <span class="font-18 w-700">หนังสือแสดงความยินยอม (Consent Form) ของข้อมูลส่วนบุคคล <br />
              <span class="font-14 w-700">ตามพระราชบัญญัติคุ้มครองข้อมูลส่วนบุคคล พ.ศ. ๒๕๖๒</span>
              <!-- <span class="font-14 w-700">ระบบ TELE Consulting</span> -->
            </span>
          </v-card-title>
        </v-card>
      </v-footer>

      <v-content class="mx-1 pt-2">
        <v-container fill-height fluid style="justify-content: center">
          <div
            id="contentScroll"
            class="pa-0 pr-2 mx-0"
            v-on:scroll="myFunction"
            style="
              max-height: 70vh;
              overflow-x: auto;
              border: 2px solid #09425a;
              border-radius: 5px;
              background-color: white;
            "
          >
            <consentUser />
          </div>
          <div class="d-flex flex-row justify-center">
            <v-btn
              class="ma-2"
              style="color: white"
              color="indigo"
              :disabled="!consentStatus"
              @click="accept"
            >
              ยอมรับ
            </v-btn>
            <v-btn class="ma-2" outlined color="#DF6668" @click="closeDialog">
              ยกเลิก
            </v-btn>
          </div>
        </v-container>
      </v-content>
    </v-app>
  </v-dialog>
</template>
<script>
import consentUser from "@/views/form/consentUser.vue";
import Swal from "sweetalert2";
import get_access_token from '@/services/get_access_token';

export default {
  components: {
    consentUser,
  },
  data() {
    return {
      businessId: this.$route.query["business_id"] || "",
      share_token: this.$route.query.share_token || "",
      // business_id: "",
      // share_toke: "",
      dialog: false,
      consentStatus: false,
      consent: false,
      dialog_loader: false,
    };
  },
  async created() {
    if (!sessionStorage.access_token || sessionStorage.access_token == "null") {
      sessionStorage.access_token = await get_access_token(this.share_token);
    }
  },
  methods: {
    openDialog(item) {
      this.dialog = true;
      // this.consentStatus = false;
      // this.consent = false;
      // this.business_id = this.item.business_id;
      this.share_token = item;
    },
    async closeDialog() {
      this.dialog = false;
      // this.$router.push(
      //   `/noti?business_id=${this.businessId}&share_token=${this.share_token}`
      // );
    },
    async accept() {
      // this.consent = true
      try {
        const params = new URLSearchParams();
        params.append("share_token", this.share_token);
        await this.axios
          .post(
            process.env.VUE_APP_BACKEND_URL + `/consent/v1?${params}`,
            {
              data: null,
            }
          )
          .then((res) => {
            if (res.data.result === "success") {
              Swal.fire({
                position: "center",
                icon: "success",
                title: "บันทึกการยินยอมสำเร็จ",
                showConfirmButton: false,
                timer: 3000,
              });
              location.reload();
              this.dialog = false;
            } else {
              Swal.fire({
                position: "center",
                icon: "error",
                title: "บันทึกการยินยอมไม่สำเร็จ",
                showConfirmButton: false,
                timer: 3000,
              });
            }
          });
      } catch (error) {
        console.log("consent error", error);
        this.$swal({
          type: "error",
          width: "auto",
          icon: "error",
          text: `consent error`,
          backdrop: false,
          showConfirmButton: false,
          timer: 1000,
        });
      }
    },
    myFunction() {
      const element = document.getElementById("contentScroll");
      let y = element.scrollTop;
      let xy =
        document.getElementById("contentScroll").scrollHeight -
        document.getElementById("contentScroll").offsetHeight;
      // console.log('y:',y);
      // console.log('xy:',  xy);
      if (y + 100 >= xy) {
        this.consentStatus = true;
      }
    },
  },
};
</script>
<style scoped>
::v-deep .v-card {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-content: center;
}
.padding-verti-50 {
  padding-bottom: 50px;
  padding-top: 50px;
}
h1 {
  font-size: 14px !important;
  /* color: #000; */
}
</style>
